<template>
<div class="chapter">
<div class="inner_page">
<p class="chap">INTRODUCTION</p>
<p class="noindent">The idea for this, my fourth, book crystallized while working on my third. I got the inspiration from Lew Powell’s <i>On This Day in North Carolina</i> (John F. Blair, 1996). I started to think about a similar book for the Outer Banks. I could write about the August 18, 1587 birth of Virginia Dare; December 17, 1903, and the Wright brothers’ first flight; and March 7, 1962, when the Ash Wednesday Storm left its calling card. After that, all I had to do was come up with 362 additional items of interest for the remaining days of the year. I was sure I could do it. The Outer Banks has a vast and vibrant four-hundred-year history ripe with a variety of tales.</p>
<p class="indent">I chose not to include too many storm or shipwreck stories, for they alone could fill a book. I did include many accounts of the gallant men and women who serve(d) in the U.S. Coast Guard and its predecessor, the United States Life-Saving Service, and many episodes that reflect the fishing and maritime heritage of the area and its surrounding waters. I hope you enjoy reading about them as much as I enjoyed discovering them.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?e6248258